import { render } from "./SessionsChart.vue?vue&type=template&id=5ca04589&ts=true"
import script from "./SessionsChart.vue?vue&type=script&lang=ts"
export * from "./SessionsChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__